export default "__VITE_ASSET__CNJKZ0Bg__"